import { DOMSerializer } from '@tiptap/pm/model';
import type { Node as ProseMirrorNode, Schema } from '@tiptap/pm/model';
import type { EditorState } from '@tiptap/pm/state';
import { htmlToMarkdown } from './serialization';

/** Serialize a ProseMirror document to the same markdown the description counter uses. */
export function docToMarkdown(doc: ProseMirrorNode, schema: Schema): string {
  const wrap = document.createElement('div');
  const fragment = DOMSerializer.fromSchema(schema).serializeFragment(doc.content);
  wrap.appendChild(fragment);
  return htmlToMarkdown(wrap.innerHTML);
}

/** Serialize a ProseMirror editor state to the same markdown the description counter uses. */
export function stateToMarkdown(state: EditorState): string {
  return docToMarkdown(state.doc, state.schema);
}
